import { createIcon } from '@chakra-ui/icons'
import React from 'react'
export const IconSquareAdd = createIcon({
  displayName: 'IconSquareAdd',
  path: [
    <path
      key="0"
      clipRule="evenodd"
      d="M3 3H21V5H5V19H19V7H21V21H3V3ZM13 13V17H11V13H7V11H11V7H13V11H17V13H13Z"
      fill="currentColor"
      fillRule="evenodd"
    />,
  ],
  viewBox: '0 0 24 24',
})
